import { render } from "./MultipleChoiceExercise.vue?vue&type=template&id=1c31206c&ts=true"
import script from "./MultipleChoiceExercise.vue?vue&type=script&lang=ts"
export * from "./MultipleChoiceExercise.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__